// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ItalicOutlinedSvg from "@ant-design/icons-svg/es/asn/ItalicOutlined";
import AntdIcon from '../components/AntdIcon';

var ItalicOutlined = function ItalicOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ItalicOutlinedSvg
  }));
};

ItalicOutlined.displayName = 'ItalicOutlined';
export default React.forwardRef(ItalicOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/ItalicOutlined.js
// module id = 1383
// module chunks = 0